import superAgent from 'superagent'
import Config from '../Config'
import NgrxAuth from '../auth/Auth'
// TODO: I'd like to find a way of doing this dynamically, but time is what it is
import CLAIM_MOCK from '../mockdata/CLAIMS.json'
import UNCLAIMEDHCSAEXPENSE_MOCK from '../mockdata/UnClaimedExpenses.json'

import {
  localize,
  getFullLocale
} from './Localizer'

import { logout } from '../redux/actions/logoutActions'

export const CALL_API = 'CALL_API'

const SUFFIX_LOADING = '_LOADING'
const SUFFIX_SUCCESS = '_SUCCESS'
const SUFFIX_FAILED = '_FAILED'

const getMock = (dispatch, prefix, onError, onSuccess) => {
  let data = null

  switch (prefix) {
    case 'CLAIMS':
      data = CLAIM_MOCK
      break
    case 'UNCLAIMED_HCSAEXPENSE':
      data = UNCLAIMEDHCSAEXPENSE_MOCK
      break
    default:
      break
  }

  if (!data) {
    console.error(`Asked for unknown mock data: ${prefix}`)
    return
  }
  let successType = `${prefix}${SUFFIX_SUCCESS}`
  let sendingType = `${prefix}${SUFFIX_LOADING}`

  dispatch({ type: sendingType })

  setTimeout(() => {
    dispatch({ type: successType, response: data })
  }, 2000)
}
const buildNoServerError = (pathForError) => {
  return {
    code: 0xFFFFFFFF,
    friendlyCode: `(${localize('error.codeNameForHex')}${0xffffffff.toString(16).toUpperCase()})`,
    message: localize('error.serverNotAvailable')
  }
}

const buildError = (err, pathForError, shouldLocalize = true) => {
  if (err) {
    const errCode = (err && err.errorCode && err.errorCode.toString(16).toUpperCase()) || ''
    const errKey = `error${pathForError}.${errCode}`
    const code = (err && err.errorCode) || ''
    const ret = {
      code: code,
      friendlyCode: `(${localize('error.codeNameForHex')}${errCode})`,
      // NOTE: removed this as we don't use local error messages from anymore and just showing error from server
      message: err.error, // shouldLocalize ? localize(errKey) : code,
      rawResponse: err
    }

    // localize will returned undefined if the error is not found in the resource file, so we
    // set the error to what the server returned
    if (ret.message === errKey || ret.message === undefined) { ret.message = err.error }

    // return the error
    return ret
  } else {
    return null
  }
}

export default store => next => action => {
  if (!action[CALL_API]) {
    return next(action)
  }

  let request = action[CALL_API]
  let { method, path, query, prefix, onError, onSuccess, mock, isFileUpload, purePath } = request
  let { dispatch } = store
  method = method || 'get'

  let failureType = `${prefix}${SUFFIX_FAILED}`
  let successType = `${prefix}${SUFFIX_SUCCESS}`
  let sendingType = `${prefix}${SUFFIX_LOADING}`

  let locale = getFullLocale()

  if (mock) {
    return getMock(dispatch, prefix, onError, onSuccess)
  }

  dispatch({ type: sendingType })
  console.log(`API_CALL to ${Config.apiUrl + path} (HTTP Request Type: ${method.toUpperCase()})`)

  let apirequest = superAgent[method](purePath || (Config.apiUrl + path))
    .set('wlkey', Config.wlKey)
    .set('Accept-Language', locale)
    .set('Authorization', NgrxAuth.isAuthenticated ? `Bearer ${NgrxAuth.accessToken}` : null)
    // .set('Access-Control-Allow-Origin', '*')

  if (isFileUpload) {
    Object.entries(query).forEach(([key, value]) => {
      if (value) {
        if (key !== 'ImageContent') {
          apirequest.field(key, value.toString())
        } else {
          apirequest.field(key, value)
        }
      }
    })
  } else {
    apirequest.send(query)
    apirequest.set('Content-Type', 'application/json')
  }

  apirequest.end((err, res) => {
    if (err) {
      // we got some sort of error so figure it out
      const pathForError = path.replace(/\//g, '.')
      if (!res) {
        console.error('bodyless res', err)
      }

      // make sure there is a response, if there is not then the server is not available
      if (!res) {
        // dispath the no server error
        dispatch({
          type: failureType,
          error: buildNoServerError(pathForError)
        })
      }

      // error object
      let error = null

      // handle an unauthorized request
      if (res && res.statusCode === 401) {
        error = buildError(res.body, pathForError, false)
        dispatch(logout(error))
      } else {
        // compose the error object
        error = buildError(res && res.body, pathForError)

        // dispatch error back to caller
        dispatch({
          type: failureType,
          error
        })
      }

      // call any callbacks
      if (onError) {
        onError(error)
      }
    } else {
      // we got an OK so dispatch success
      dispatch({
        type: successType,
        response: res.body
      })
      if (onSuccess) {
        onSuccess(res.body)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/util/RBRestMiddleware.js